import { render, staticRenderFns } from "./UpgradeForm.vue?vue&type=template&id=8ad6d510"
import script from "./UpgradeForm.vue?vue&type=script&lang=js"
export * from "./UpgradeForm.vue?vue&type=script&lang=js"
import style0 from "./UpgradeForm.vue?vue&type=style&index=0&id=8ad6d510&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports